<script setup lang="ts">
import { computed, storeToRefs, useRuntimeConfig } from '#imports';
import type { TEvent } from './../types';
import { useDialogEventStore } from './../store';

const props = withDefaults(defineProps<{
	modelValue: boolean;
}>(), {
	modelValue: false,
});

const emit = defineEmits<{
	(e: 'update:modelValue'): void;
}>();

const value = computed({
	get: () => props.modelValue,
	set: () => emit('update:modelValue'),
});

const dialogEventStore = useDialogEventStore();
const { events } = storeToRefs(dialogEventStore);

const date = computed(() => new Date().toLocaleDateString('ru-RU'));

const config = useRuntimeConfig();

const linkParams = (event: TEvent) => {
	const attrs: Record<string, unknown> = {};

	if (event.url.includes(config.public.SITE_URL as string)) {
		attrs.to = `/news/${event.news_id}/`;
	} else {
		attrs.href = event.url;
		attrs.target = '_blank';
		attrs.rel = 'me noreferrer';
	}

	return attrs;
};

const linkListeners = (event: TEvent) => {
	const listeners: Record<string, unknown> = {};

	if (event.url.includes(config.public.SITE_URL as string)) {
		listeners.click = () => emit('update:modelValue');
	}

	return listeners;
};
</script>

<template>
	<v-dialog v-model="value">
		<div class="dialog-event">
			<p class="dialog-event__date">
				Сегодня, {{ date }} — день, когда:
			</p>

			<ul v-if="events?.length > 0" class="dialog-event__list">
				<li
					v-for="event in events"
					:key="event.id"
					class="dialog-event__list-item"
				>
					<v-link v-bind="linkParams(event)" v-on="linkListeners(event)">
						{{ event.name }}
					</v-link>
				</li>
			</ul>

			<p v-else class="mt-20">
				Ничего не произошло.
			</p>
		</div>
	</v-dialog>
</template>

<style lang="scss" scoped>
.dialog-event {
	&__date {
		font-weight: bold;

		margin-bottom: rem($gap-mini);
	}

	&__list {
		margin-top: rem($gap-small);
		padding-left: rem($gap-micro);

		&-item {
			$size-dot: 3px;

      position: relative;

      margin-bottom: rem($gap-mini);
      padding-left: rem($gap-small);

      @include reset-indent-last;

      &::before {
        position: absolute;
        top: em(8px);
        left: em(1px);

        display: block;

        width: rem($size-dot);
        height: rem($size-dot);

        content: "";

        color: $black;
        border-radius: 50%;
        background-color: currentColor;
      }
		}

		a {
			text-decoration: none;

			@include hover {
				text-decoration: underline;
			}
		}
	}
}
</style>
